import {createAction, props} from '@ngrx/store';

export const GetWizardContent = createAction(
    '[Wizard] Get wizard content',
    props<{ consentId: string }>()
);

export const GetWizardContentSuccess = createAction(
    '[Wizard] Wizard content success',
    props<{ wizardContent: string }>()
);

export const SetWizardContent = createAction(
    '[Wizard] Set wizard content',
    props<{ wizardContent: any }>()
);
